import { Flex, useColorMode, Switch, Text } from '@chakra-ui/react';

export const DarkMode = () => {
    const { colorMode, toggleColorMode } = useColorMode();

    return (
        <Flex className="color-mode">
            <Text>Dark Mode</Text>
            <Switch
                className="settings-switch"
                isChecked={colorMode === 'light'}
                onChange={toggleColorMode}
            />
            <Text>Light Mode</Text>
        </Flex>
    );
};
